module.exports = __webpack_public_path__ + "img/man.50b7b3cc.png";